module.exports = __webpack_public_path__ + "static/img/icon-jpg.8603728d.jpg";